import { createFileRoute } from '@tanstack/react-router';
import CreateFee from '../../../features/baseData/fees/fee/create';
import {
  createPermissionGuard,
  FEES_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/gebuehren/neu')({
  component: CreateFee,
  beforeLoad: createPermissionGuard(getPermissionSet(FEES_PERMISSIONS, 'EDIT')),
});

export const CreateFeeRoute = Route;
